import { Location } from '@angular/common';
import { Component, ErrorHandler, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Errors } from 'src/infrastructure/labels/errors';
import { Successes } from 'src/infrastructure/labels/successes';
import { ValidationConfig } from 'src/infrastructure/validation/validationConfig';
import { Validator } from 'src/infrastructure/validation/validator';
import { AuthTokenDTO } from 'src/models/DTO/token/authToken';
import { createLoginRequestModel } from 'src/models/requestModels/login/createLoginRequestModel';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { ToastService } from 'src/services/core/toast/toast.service';
import { AuthenticationService } from 'src/services/request/authentication/authentication.service';
import { UserInfoService } from 'src/services/request/user/userinfo.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends HistoryBaseComponent implements OnInit {

  public loginInfo: FormGroup;

  constructor(
    private FB: FormBuilder,
    private toastr: ToastService,
    private router: Router,
    private loginService: AuthenticationService,
    private localStorageService: LocalstorageService,
    private userInfoService: UserInfoService,
    private userStateService: LoggedUserService,
    protected location: Location,
    protected historyService: HistoryService

    ) {
    super(location, historyService);
    this.pageTitle = 'login';
    this.loginInfo = FB.group({
      password: ['', [Validators.required]],
      rememberMe: [true, [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.email)]]
    })
  }

  ngOnInit(): void {
  }

  login() {
    this._error = Validator.FormGroupValidator.validate(this.loginInfo);
    if (!this.loginInfo.get("email")?.valid) {
      this.toastr.error("Въвели сте грешен имейл");
      return;
    }
    const login: createLoginRequestModel = {
      password: this.loginInfo.get('password')?.value,
      rememberMe: this.loginInfo.get('rememberMe')?.value,
      email: this.loginInfo.get('email')?.value
    };
    this.loginService.loginUser(login).subscribe((authToken) => {
      this.localStorageService.setLocalStorageItem(Config.lsTokenKey, authToken.data.token);
      this.userInfoService.loadUser().subscribe(user => {
        this.userStateService.addNewUser(user);
        this.toastr.success(Successes.bg.loginUser);
        this.router.navigate(['bottomtabs/home/']);
      })
    })
  }

  registration() {
    this.router.navigate(['registration']);
  }

  forgottenPassword() {
    this.router.navigate(['password/forgotten']);
  }

  initiateForgottenPassword() {
    console.log("Forgotten Passowrd")
  }

  trim(emailEvent: EventTarget | null) {
    if (!emailEvent) return;
    let email = (emailEvent as HTMLInputElement).value;
    email = email.trim();
    this.loginInfo.get('email')?.setValue(email);
  }

}
